module.exports = __webpack_public_path__ + "static/media/report.863b183c.svg";